import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { PreviousEmploymentStyled } from '../../asset/styled/PreviousEmploymentStyled';

import PreviousEmploymentList from './PreviousEmploymentList';
import InfoBanner from '../../components/Banner';
import AddButtonSection from './AddButtonSection';
import ConfirmDialog from './ConfirmDialog';
import PreviousEmploymentAdd from './add';
import { getPreviousEmploymentList, resetPreviousEmployment } from './previousSlice';
import { magamCertifyCheck } from '../../common/Util';

const PreviousEmployment = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('previousEmployment');
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(null); // '1': 전직장, '2': 납세조합
  const [selectedHtmSeq, setSelectedHtmSeq] = useState(null); // 선택된 항목의 htmSeq (수정 모드용)
  const { isRender, reload } = useSelector(state => state.previousEmployment);
  const { isMagam, isCertify } = useSelector(state => state.common);

  useEffect(() => {
    if (!isRender || reload !== -1) {
      dispatch(getPreviousEmploymentList());
    }
  }, [reload, dispatch]);

  //언마운트시 데이터 초기화
  useEffect(() => {
    return () => {
      dispatch(resetPreviousEmployment());
    };
  }, []);

  // 리스트 아이템 클릭 핸들러 (수정 모드로 열기)
  const handleItemClick = (htmSeq, htmJType) => {
    setSelectedHtmSeq(htmSeq);
    setSelectedType(htmJType);
    setIsAddOpen(true);
  };

  // 추가/수정 닫기 핸들러
  const handleAddClose = () => {
    setIsAddOpen(false);
    setSelectedHtmSeq(null);
  };

  // 추가 버튼 클릭 핸들러
  const handleAddClick = type => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    setSelectedType(type);
    setSelectedHtmSeq(null); // 새로 추가하는 경우 htmSeq 초기화
    // 전직장(1)일 때만 ConfirmDialog 표시, 납세조합(2)은 바로 추가 화면으로
    if (type === '1') {
      setIsConfirmOpen(true);
    } else {
      setIsAddOpen(true);
    }
  };

  // ConfirmDialog 확인 버튼 핸들러
  const handleConfirm = () => {
    setIsConfirmOpen(false);
    setSelectedHtmSeq(null); // 새로 추가하는 경우 htmSeq 초기화
    setIsAddOpen(true);
  };

  if (!isRender) {
    return null;
  }

  return (
    <PreviousEmploymentStyled>
      <InfoBanner title={t('bannerSection.title')} description={t('bannerSection.description')} />

      {/* 전직장 추가 버튼 섹션 */}
      <AddButtonSection onClickButton={handleAddClick} />

      {/* 전직장, 납세조합 정보 */}
      <PreviousEmploymentList onItemClick={handleItemClick} />

      {/* 확인 다이얼로그 */}
      <ConfirmDialog
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirm}
      />

      {/* 전직장 추가/수정 */}
      <PreviousEmploymentAdd
        isOpen={isAddOpen}
        onClose={handleAddClose}
        htmJType={selectedType}
        htmSeq={selectedHtmSeq}
      />
    </PreviousEmploymentStyled>
  );
};

export default PreviousEmployment;
